var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCallPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1209_5920",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1209_5920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8333 20C16.4444 20 14.1159 19.4674 11.8478 18.4022C9.57889 17.3378 7.56963 15.9304 5.82 14.18C4.06963 12.4304 2.66222 10.4211 1.59778 8.15222C0.532593 5.88407 0 3.55556 0 1.16667C0 0.833334 0.111111 0.555556 0.333333 0.333333C0.555556 0.111111 0.833334 0 1.16667 0H5.66667C5.92593 0 6.15741 0.0833332 6.36111 0.25C6.56482 0.416667 6.68519 0.62963 6.72222 0.888889L7.44444 4.77778C7.48148 5.03704 7.47704 5.27296 7.43111 5.48556C7.38444 5.69889 7.27778 5.88889 7.11111 6.05556L4.41667 8.77778C5.19444 10.1111 6.17148 11.3611 7.34778 12.5278C8.52333 13.6944 9.81482 14.7037 11.2222 15.5556L13.8333 12.9444C14 12.7778 14.2178 12.6526 14.4867 12.5689C14.7548 12.4859 15.0185 12.463 15.2778 12.5L19.1111 13.2778C19.3704 13.3333 19.5833 13.4581 19.75 13.6522C19.9167 13.847 20 14.0741 20 14.3333V18.8333C20 19.1667 19.8889 19.4444 19.6667 19.6667C19.4444 19.8889 19.1667 20 18.8333 20ZM3.36111 6.66667L5.19445 4.83333L4.72222 2.22222H2.25C2.34259 2.98148 2.47222 3.73148 2.63889 4.47222C2.80556 5.21296 3.0463 5.94444 3.36111 6.66667ZM13.3056 16.6111C14.0278 16.9259 14.7641 17.1759 15.5144 17.3611C16.2641 17.5463 17.0185 17.6667 17.7778 17.7222V15.2778L15.1667 14.75L13.3056 16.6111Z",
    fill: "#00BCE7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCallPrimary);
export default __webpack_public_path__ + "static/media/ic-call-primary.e7bd6ba5a08ba567439e75cc799e0ca8.svg";
export { ForwardRef as ReactComponent };